import { useFetchProfileCurrentQuery } from '../api/profile';

/**
 * Centralized hook for profile data management
 * This hook provides consistent profile completion logic across the application
 */
export const useProfileData = () => {
    const { data: profileData, isLoading, isError, error, refetch } = useFetchProfileCurrentQuery({});

    // Standardized profile completion logic
    // Profile is complete if it has both first_name and last_name
    const isProfileComplete = Boolean(profileData?.first_name && profileData?.last_name);
    
    // Profile has data (but might not be complete)
    const hasProfileData = Boolean(profileData && Object.keys(profileData).length > 0);
    
    // Profile is empty or doesn't exist
    const isProfileEmpty = !hasProfileData;

    return {
        // Raw data
        profileData,
        
        // Loading states
        isLoading,
        isError,
        error,
        
        // Profile completion states
        isProfileComplete,
        hasProfileData,
        isProfileEmpty,
        
        // Actions
        refetch
    };
};
